/** 添加千分分割逗号 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function addComma(num: any) {
  
  const numArr: any = String(Number(num).toFixed(2)).split('.');
  // eslint-disable-next-line prefer-destructuring
  let numb: string = numArr[0];
  let result = '';

  while (numb.length > 3) {
    result = `,${numb.slice(-3)}${result}`;
    numb = numb.slice(0, numb.length - 3);
  }
  if (numb) {
    result = numb + result;
  }
  result = numArr[1] ? `${result}.${numArr[1]}` : `${result}`;
  return result;
}
